/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MusicNoteIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Music Note',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M17.17627,1.58887c-.52344-.42773-1.20459-.59668-1.86719-.46582l-7.00049,1.40039c-1.04785.20996-1.80859,1.1377-1.80859,2.20605v8.99646c-.85083-.32532-1.94965-.29114-3.02637.18811-1.82373.81348-2.77344,2.52441-2.1626,3.89551.30908.69238.98584,1.18164,1.85693,1.3418.2124.03906.43213.05762.65625.05762.6001,0,1.23145-.1377,1.83008-.4043.82275-.36719,1.50439-.94141,1.91992-1.61816.28088-.45801.42566-.94116.42578-1.40723V7.15039l8.5-1.69995v6.27539c-.85065-.3252-1.9491-.29102-3.02637.18823-1.82373.81348-2.77344,2.52441-2.1626,3.89551.30908.69238.98584,1.18164,1.85693,1.3418.2124.03906.43213.05762.65625.05762.6001,0,1.23145-.1377,1.83008-.4043.82275-.36719,1.50439-.94141,1.91992-1.61816.28088-.45801.42566-.94116.42578-1.40723V3.33008c0-.67676-.30029-1.31152-.82373-1.74121ZM5.04346,17.43457c-.54199.24023-1.12793.32812-1.60498.24121-.22119-.04102-.61426-.15625-.75732-.47754-.22656-.50781.29443-1.41992,1.40332-1.91406.43408-.19336.85547-.27734,1.2207-.27734.56934,0,1.00391.20312,1.1416.5127.03571.07983.05139.16284.05322.24548.00488.24939-.11609.49329-.20459.63733-.25439.41406-.71045.79102-1.25195,1.03223ZM16.5,13.7666c.00488.2478-.11609.4917-.20459.63574-.25439.41406-.71045.79102-1.25195,1.03223-.5415.24023-1.12646.3291-1.60498.24121-.22119-.04102-.61426-.15625-.75732-.47754-.22656-.50781.29443-1.41992,1.40332-1.91406.43408-.19336.85547-.27734,1.2207-.27734.56934,0,1.00391.20312,1.1416.5127.03571.07983.05139.16284.05322.24707ZM16.5,3.9209l-8.5,1.69995v-.89136c0-.35547.25391-.66504.60303-.73535l7-1.40039c.22021-.04395.44775.01074.62207.15527.1748.14355.2749.35547.2749.58105v.59082Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
